import { EventImage } from "./EventImage";

export default EventImage;